export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['会員情報']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ダッシュボード',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員情報',
        to: '/profile',
        icon: 'cil-pencil',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Eメール設定',
        to: '/email-settings',
        icon: 'cil-pencil',
      },
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['クーポン情報'],
      //   _class: 'parent_tab'
      // },
      //{
      //  _name: 'CSidebarNavItem',
      //  name: '割引一覧',
      //  to: '/discount-list',
      //  icon: 'cil-pencil',
      //},
     /*  {
        _name: 'CSidebarNavItem',
        name: '会員検索',
        to: '/member-search',
        icon: 'cil-list',
      }, */
      /* {
        _name: 'CSidebarNavTitle',
        _children: ['クーポン情報']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン',
        to: '/coupon-create',
        icon: 'cil-plus',
      },  
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン編集',
        to: '/coupon-edit',
        icon: 'cil-pencil',
      },         
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン一覧',
        to: '/coupon-list',
        icon: 'cil-list',
      }, 
      {
        _name: 'CSidebarNavTitle',
        _children: ['ポイント情報']
      },*/
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'ポイント更新履歴',
      //   to: '/pointhistory',
      //   icon: 'cil-list',
      // },
      /* {
        _name: 'CSidebarNavTitle',
        _children: ['お問合せ']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'お問合せ',
        to: '/inquiry',
        icon: 'cil-comment-square' 
      },
      {
        _name: 'CSidebarNavItem',
        name: 'お問合せ一覧',
        to: '/inquirylist',
        icon: 'cil-comment-square' 
      },
      {
        _name: 'CSidebarNavItem',
        name: '顧客問合せ一覧',
        to: '/customerinquirylist',
        icon: 'cil-comment-square' 
      },
      {
        _name: 'CSidebarNavItem',
        name: 'カード会員登録',
        to: '/members-card-add',
        icon: 'cil-pencil', 
      }, */
      {
        _name: 'CSidebarNavTitle',
        _children: ['ログアウト']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログアウト',
        to: '/logout',
        icon: 'cil-room' 
      }  
    ]
  }
]